"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFragment = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MARKER_REPLACE_PATTERN = /[{}]/g;

var createFragment = function createFragment(params, item, key) {
  var index = item.replace(MARKER_REPLACE_PATTERN, "");
  var fragment = params[index];

  if (_react["default"].isValidElement(fragment)) {
    return _react["default"].createElement(_react["default"].Fragment, {
      key: key
    }, fragment);
  }

  return fragment;
};

exports.createFragment = createFragment;